module.exports = __webpack_public_path__ + "img/unionpay.511191db.svg";